import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import { Routes } from '@angular/router';
import {
  OpinionOnIssuingADecisionApplicationDataComponent
} from './sections/opinion-on-issuing-a-decision-application-data/opinion-on-issuing-a-decision-application-data.component';

export const stages: string[] = [
  'Dane wniosku',
  'Zgody',
  'Załączniki'
];

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../dane-wniosku',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const opinionOnIssuingADecisionRoutes: Routes = [
  {
    component: OpinionOnIssuingADecisionApplicationDataComponent,
    path: 'dane-wniosku'
  },
  {
    component: OpinionOnIssuingADecisionApplicationDataComponent,
    path: ':appId/dane-wniosku'
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'dane-wniosku', pathMatch: 'prefix' }
];
